<template>
  <master-crud-page
    master="notification/topic"
    title="Notification Topic"
    access="master_notification_topic"
    pk="ntopId"
    :columns="columns"
    :fields="fields"
    :filters="filters"
    :embedded="embedded"
    page-size-selectable
    forbidden-text="This module is internal only."
  />
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import {
  CATEGORY_OPTIONS, SEVERITY_OPTIONS, AUDIENCE_SCOPE_OPTIONS, STATUS_OPTIONS,
  TOPIC_CHANNEL_OPTIONS, severityVariant, statusColumn,
} from '@/util/notificationConfig';

export default {
  name: 'MasterNotificationTopic',
  components: { MasterCrudPage },
  props: {
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      columns: [
        {
          key: 'ntopCode', label: 'Code', align: 'left', tdClass: 'text-monospace',
        },
        { key: 'ntopName', label: 'Name', align: 'left' },
        {
          key: 'ntopCategory', label: 'Category', type: 'badge', variant: () => 'secondary',
        },
        {
          key: 'ntopDefaultSeverity',
          label: 'Severity',
          type: 'badge',
          variant: (row) => severityVariant(row.ntopDefaultSeverity),
        },
        { key: 'ntopAudienceScope', label: 'Audience' },
        { key: 'ntopDefaultChannels', label: 'Channels' },
        statusColumn('ntopEnabled', 'Status'),
      ],
      fields: [
        {
          key: 'ntopCode', label: 'Code', type: 'text', required: true, placeholder: 'alert.device_offline', lockOnEdit: true,
        },
        {
          key: 'ntopName', label: 'Name', type: 'text', required: true,
        },
        {
          key: 'ntopCategory', label: 'Category', type: 'select', required: true, options: CATEGORY_OPTIONS, lockOnEdit: true,
        },
        {
          key: 'ntopDefaultSeverity', label: 'Default Severity', type: 'select', options: SEVERITY_OPTIONS, default: 'WARNING',
        },
        {
          key: 'ntopAudienceScope', label: 'Audience Scope', type: 'select', options: AUDIENCE_SCOPE_OPTIONS, default: 'internal',
        },
        {
          key: 'ntopEnabled', label: 'Status', type: 'select', options: STATUS_OPTIONS, default: 1,
        },
        {
          key: 'ntopDefaultChannels',
          label: 'Default Channels',
          type: 'checkbox-group',
          options: TOPIC_CHANNEL_OPTIONS,
          default: 'inapp',
          colMd: 12,
        },
        {
          key: 'ntopSourceType', label: 'Source Type', type: 'text', lockOnEdit: true,
        },
        {
          key: 'ntopSourceKey', label: 'Source Key', type: 'text', lockOnEdit: true,
        },
      ],
      filters: [
        {
          key: 'ntopCategory', label: 'Category', type: 'select', options: CATEGORY_OPTIONS, colMd: 3,
        },
        {
          key: 'ntopEnabled', label: 'Status', type: 'select', options: STATUS_OPTIONS, colMd: 3,
        },
        { key: 'ntopName', label: 'Search name', colMd: 3 },
      ],
    };
  },
};
</script>
